import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { ApplicationClientCommonModule, CommonFormattingModule, CommonLayoutModule, CommonTranslationModule } from '@sdbn/common';
import { ExportVisitorLogComponent } from './components/export-visitor-log.component';

@NgModule({
  declarations: [
    ExportVisitorLogComponent
  ],
  imports: [
    CommonModule,
    CommonTranslationModule,
    ApplicationClientCommonModule,
    CommonLayoutModule,
    ReactiveFormsModule,
    CommonFormattingModule,
    MatTableModule
  ],
  exports: [
    ExportVisitorLogComponent
  ]

})
export class ExportVisitorLogModule { }
